import Vue from 'vue'
import VueRouter from 'vue-router'
import Request from '@/views/Request.vue'
import Item from "@/views/Item";
import Catalogue from "@/views/Catalogue";
import PageNotFound from "@/views/404";
import NProgress from 'nprogress';
import store from '@/store';
import NetworkError from "@/views/NetworkError";
import ActiveRequests from "@/views/ActiveRequests";
import Home from "@/views/Home";
import Payment from "@/views/Payment";
import MerchantAddProductsWhatsapp from "@/views/MerchantAddProductsWhatsapp";
import MerchantAddProductsInstagram from "@/views/MerchantAddProductsInstagram";
import TermsAndConditions from "@/views/TermsAndConditions";

Vue.use(VueRouter)

const routes = [
  { path: '/error/network', name: 'network-error', component: NetworkError },
  { path: '/error/404', name: 'not-found', component: PageNotFound },

  { path: '/terms', name: 'terms', component: TermsAndConditions },

  { path: '/:mid', name: 'store', component: Home, exact: true },
  { path: '/:mid/collections', name: 'collections', component: Catalogue },
  { path: '/:mid/item/:pid', name: 'item', component: Item },

  { path: '/:mid/products/whatsapp', name: 'add-products-whatsapp', component: MerchantAddProductsWhatsapp },
  { path: '/:mid/products/instagram', name: 'add-products-instagram', component: MerchantAddProductsInstagram },

  { path: '/payment/:token', name: 'payment', component: Payment },
  { path: '/request/:rid', name: 'request', component: Request },
  { path: '/request/:rid/all', name: 'active-requests', component: ActiveRequests },

  { path: '*', component: PageNotFound },
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const clearStore = () => {
  store.commit('catalogue/clear');
  store.commit('merchant/clear');
  store.commit('global/clear');
  store.commit('merchant/clear');
}

const fetchMerchant = async (slug) => {
  const id = await store.dispatch('merchant/resolveId', slug);
  await store.dispatch('merchant/get', id || slug);
}

router.beforeResolve(async (to, from, next) => {
  if (to.name) NProgress.start();
  try {
    const { rid, mid } = to.params;
    if (mid) {
      if (store.state.merchant.id) {
        if (store.state.merchant.slug !== mid) {
          clearStore();
          await fetchMerchant(mid)
        }
      } else {
        await fetchMerchant(mid)
      }
    } else {
      if (!rid) clearStore();
    }
    if (rid) {
      const id = await store.dispatch('request/resolveId', rid);
      +store.state.request.id !== +rid && await store.dispatch('request/load', id || rid);
      !store.state.merchant.id && await store.dispatch('merchant/get', store.state.request.merchant_id);
    }
  } catch (e) {
    if ('response' in e) {
      if (!e.response) return next('/error/network');
      if (e.response.status >= 400 && e.response.status < 500) return next('/error/404');
      else return next('/error/404');
    }
    return next('/error/404');
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
})

export default router
